import { GameMode } from "@rosette/ts/src/business/game/GameMode.js";
import { Selector } from "@/components/gamesetup/Selector.js";
import type { RefObject } from "react";
import { getGameModeIcon } from "@/components/icon/getGameModeIcon.js";
import type { SelectorOption } from "@/components/gamesetup/SelectorOptionElem.js";


interface ModeSelectorOptions {
    selectedMode: GameMode;
    setSelectedMode: (mode: GameMode) => void;
    scrollRef: RefObject<HTMLHeadingElement | null>;
}

/**
 * A selector for choosing the game mode.
 */
export function ModeSelector({
    selectedMode, setSelectedMode, scrollRef,
}: ModeSelectorOptions) {

    const options: SelectorOption<GameMode>[] = [];
    for (const mode of [GameMode.COMPUTER, GameMode.FRIEND, GameMode.ONLINE, GameMode.LOCAL]) {
        options.push({
            value: mode,
            name: mode.getPlayText(),
            desc: mode.getDesc(),
            icon: getGameModeIcon(mode),
        });
    }

    return (
        <Selector
            style="flat"
            scrollRef={scrollRef}
            options={options}
            inlineIcon={false}
            selection={selectedMode}
            setSelection={setSelectedMode} />
    );
}
